import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider } from './AdminAuthContext';
import AdminLayout from './components/AdminLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import LeadsPage from './pages/LeadsPage';
import ContactsPage from './pages/ContactsPage';
import CmsPage from './pages/CmsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import SeoPage from './pages/SeoPage';

const AdminRouter = () => (
  <AdminAuthProvider>
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="*" element={
        <AdminLayout>
          <Routes>
            <Route index element={<DashboardPage />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="contatos" element={<ContactsPage />} />
            <Route path="cms" element={<CmsPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="seo" element={<SeoPage />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </AdminLayout>
      } />
    </Routes>
  </AdminAuthProvider>
);

export default AdminRouter;
